<div class="submitted-container">
  <div class="card">
    <div class="icon-container">
      <mat-icon class="success-icon">check_circle</mat-icon>
    </div>
    <h1>Formulário Enviado!</h1>
    <p>Obrigado por enviar o formulário. Seus dados foram registrados com sucesso.</p>
  </div>
</div>
